//Core
import React from "react"

//Components
import Header from "./Header"
import BlocksTravel from "../../components/BlocksTravel"

import first from "../../images/travel/first.svg"
import second from "../../images/travel/second.svg"
import third from "../../images/travel/third.svg"

const blocks = [
  {
    img: first,
    title: `Хто може брати участь в акції?`,
    subtitle: `Будь-який клієнт, у якого є картка Велика П'ятірка та якому надійшло персональне SMS/ VIBER повідомлення про акцію `,
    end: true,
  },
  {
    img: second,
    title: `Як стати учасником акції?`,
    subtitle: `Зареєструйтесь та здійснюйте покупки кредитними коштами з 1 по 31 березня 2020 на суму чеку від 500 грн`,
  },
  {
    img: third,
    title: `Який подарунок?`,
    subtitle: `Переможець отримає сертифікат номіналом 30 000 грн на будь-яку подорож `,
    end: true,
  },
]

const Travel = () => {
  return (
    <div>
      <Header></Header>
      <BlocksTravel blocks={blocks}></BlocksTravel>
    </div>
  )
}

export default Travel
